// Display bounds used by ChartRepository::getCategoryRanges; not an independent scoring table.
export const powerProfileRanges = {
  "male": {
    "power5sec": [
      {
        "category": "World Class",
        "min": 23.26,
        "max": 26.0
      },
      {
        "category": "Exceptional",
        "min": 21.48,
        "max": 23.26
      },
      {
        "category": "Excellent",
        "min": 19.7,
        "max": 21.48
      },
      {
        "category": "Very Good",
        "min": 17.6,
        "max": 19.7
      },
      {
        "category": "Good",
        "min": 15.85,
        "max": 17.6
      },
      {
        "category": "Moderate",
        "min": 14.1,
        "max": 15.85
      },
      {
        "category": "Fair",
        "min": 12.3,
        "max": 14.1
      },
      {
        "category": "Untrained",
        "min": 10.08,
        "max": 12.3
      }
    ],
    "power1min": [
      {
        "category": "World Class",
        "min": 10.76,
        "max": 13.0
      },
      {
        "category": "Exceptional",
        "min": 10.07,
        "max": 10.76
      },
      {
        "category": "Excellent",
        "min": 9.38,
        "max": 10.07
      },
      {
        "category": "Very Good",
        "min": 8.57,
        "max": 9.38
      },
      {
        "category": "Good",
        "min": 7.88,
        "max": 8.57
      },
      {
        "category": "Moderate",
        "min": 7.18,
        "max": 7.88
      },
      {
        "category": "Fair",
        "min": 6.5,
        "max": 7.18
      },
      {
        "category": "Untrained",
        "min": 5.64,
        "max": 6.5
      }
    ],
    "power5min": [
      {
        "category": "World Class",
        "min": 7.03,
        "max": 8.0
      },
      {
        "category": "Exceptional",
        "min": 6.31,
        "max": 7.03
      },
      {
        "category": "Excellent",
        "min": 5.69,
        "max": 6.31
      },
      {
        "category": "Very Good",
        "min": 4.96,
        "max": 5.69
      },
      {
        "category": "Good",
        "min": 4.34,
        "max": 4.96
      },
      {
        "category": "Moderate",
        "min": 3.72,
        "max": 4.34
      },
      {
        "category": "Fair",
        "min": 3.1,
        "max": 3.72
      },
      {
        "category": "Untrained",
        "min": 2.33,
        "max": 3.1
      }
    ],
    "power20min": [
      {
        "category": "World Class",
        "min": 5.83,
        "max": 7.0
      },
      {
        "category": "Exceptional",
        "min": 5.29,
        "max": 5.83
      },
      {
        "category": "Excellent",
        "min": 4.76,
        "max": 5.29
      },
      {
        "category": "Very Good",
        "min": 4.14,
        "max": 4.76
      },
      {
        "category": "Good",
        "min": 3.6,
        "max": 4.14
      },
      {
        "category": "Moderate",
        "min": 3.07,
        "max": 3.6
      },
      {
        "category": "Fair",
        "min": 2.54,
        "max": 3.07
      },
      {
        "category": "Untrained",
        "min": 1.86,
        "max": 2.54
      }
    ]
  },
  "female": {
    "power5sec": [
      {
        "category": "World Class",
        "min": 18.0,
        "max": 22.0
      },
      {
        "category": "Exceptional",
        "min": 16.72,
        "max": 18.0
      },
      {
        "category": "Excellent",
        "min": 15.42,
        "max": 16.72
      },
      {
        "category": "Very Good",
        "min": 13.92,
        "max": 15.42
      },
      {
        "category": "Good",
        "min": 12.62,
        "max": 13.92
      },
      {
        "category": "Moderate",
        "min": 11.33,
        "max": 12.62
      },
      {
        "category": "Fair",
        "min": 10.04,
        "max": 11.33
      },
      {
        "category": "Untrained",
        "min": 8.43,
        "max": 10.04
      }
    ],
    "power1min": [
      {
        "category": "World Class",
        "min": 8.71,
        "max": 11.0
      },
      {
        "category": "Exceptional",
        "min": 8.17,
        "max": 8.71
      },
      {
        "category": "Excellent",
        "min": 7.63,
        "max": 8.17
      },
      {
        "category": "Very Good",
        "min": 6.98,
        "max": 7.63
      },
      {
        "category": "Good",
        "min": 6.44,
        "max": 6.98
      },
      {
        "category": "Moderate",
        "min": 5.9,
        "max": 6.44
      },
      {
        "category": "Fair",
        "min": 5.35,
        "max": 5.9
      },
      {
        "category": "Untrained",
        "min": 4.67,
        "max": 5.35
      }
    ],
    "power5min": [
      {
        "category": "World Class",
        "min": 6.12,
        "max": 7.5
      },
      {
        "category": "Exceptional",
        "min": 5.55,
        "max": 6.12
      },
      {
        "category": "Excellent",
        "min": 4.98,
        "max": 5.55
      },
      {
        "category": "Very Good",
        "min": 4.31,
        "max": 4.98
      },
      {
        "category": "Good",
        "min": 3.74,
        "max": 4.31
      },
      {
        "category": "Moderate",
        "min": 3.17,
        "max": 3.74
      },
      {
        "category": "Fair",
        "min": 2.6,
        "max": 3.17
      },
      {
        "category": "Untrained",
        "min": 1.88,
        "max": 2.6
      }
    ],
    "power20min": [
      {
        "category": "World Class",
        "min": 5.17,
        "max": 6.0
      },
      {
        "category": "Exceptional",
        "min": 4.67,
        "max": 5.17
      },
      {
        "category": "Excellent",
        "min": 4.18,
        "max": 4.67
      },
      {
        "category": "Very Good",
        "min": 3.6,
        "max": 4.18
      },
      {
        "category": "Good",
        "min": 3.11,
        "max": 3.6
      },
      {
        "category": "Moderate",
        "min": 2.62,
        "max": 3.11
      },
      {
        "category": "Fair",
        "min": 2.12,
        "max": 2.62
      },
      {
        "category": "Untrained",
        "min": 1.5,
        "max": 2.12
      }
    ]
  }
} as const;
export type PowerProfileReferenceSex = keyof typeof powerProfileRanges;
export function resolvePowerProfileReference(interval: string, category: string, min: unknown, max: unknown): PowerProfileReferenceSex | undefined {
  if (typeof min !== 'number' || typeof max !== 'number') return undefined;
  return (['male', 'female'] as const).find(sex => {
    const rows = powerProfileRanges[sex][interval as keyof typeof powerProfileRanges.male];
    return rows?.some(row => row.category === category && Math.abs(row.min - min) < 0.001 && Math.abs(row.max - max) < 0.001);
  });
}
